import Logo from "./icon.png"

export const images={
    Logo
}